export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";
export const UPDATE_LOADING = "UPDATE_LOADING";
export const SET_CURRENT_USER = "SET_CURRENT_USER";

